/**
 * Icon Wrappers - Material Design Icons from react-icons
 * Proper wrapper components to fix TypeScript JSX issues
 */

import {
  MdDashboard,
  MdAutoAwesome,
  MdPeople,
  MdInventory2,
  MdLocationOn,
  MdTrendingUp,
  MdShoppingCart,
  MdShoppingBag,
  MdMenuBook,
  MdSettings,
  MdPersonAdd,
  MdReceipt,
  MdHeadsetMic,
  MdNotifications,
  MdPerson,
  MdLogout,
  MdSearch,
  MdExpandMore,
  MdLayers,
  MdStorage,
  MdLocalOffer,
  MdVerifiedUser,
  MdAccountBalance,
  MdPayments,
  MdMap,
  MdEmojiEvents,
  MdBarChart,
  MdReceiptLong,
  MdDateRange,
  MdMyLocation,
} from 'react-icons/md';

// Simple wrapper function for all icons
const createIcon = (Icon: any) => () => <Icon />;

// Dashboard & Overview
export const OverviewIcon = createIcon(MdDashboard);
export const DashboardIcon = createIcon(MdDashboard);

// AI Insights
export const AiIcon = createIcon(MdAutoAwesome);

// Management Icons
export const CustomersIcon = createIcon(MdPeople);
export const InventoryIcon = createIcon(MdInventory2);
export const RoutesIcon = createIcon(MdLocationOn);
export const SalesIcon = createIcon(MdTrendingUp);
export const OrdersIcon = createIcon(MdShoppingBag);
export const CartIcon = createIcon(MdShoppingCart);
export const CatalogIcon = createIcon(MdMenuBook);
export const CategoriesIcon = createIcon(MdLayers);

// Finance Icons
export const InvoicesIcon = createIcon(MdReceipt);
export const PaymentsIcon = createIcon(MdPayments);
export const ComplianceIcon = createIcon(MdVerifiedUser);
export const AccountingIcon = createIcon(MdAccountBalance);

// Operations Icons
export const OnboardingIcon = createIcon(MdPersonAdd);
export const LiveTrackingIcon = createIcon(MdMyLocation);
export const SupportIcon = createIcon(MdHeadsetMic);

// Header Icons
export const BellIcon = createIcon(MdNotifications);
export const UserIcon = createIcon(MdPerson);
export const LogoutIcon = createIcon(MdLogout);
export const SearchIcon = createIcon(MdSearch);
export const SettingsIcon = createIcon(MdSettings);
export const CalendarIcon = createIcon(MdDateRange);
export const ChevronDownIcon = createIcon(MdExpandMore);

// Specialized Icons
export const PurchaseIcon = createIcon(MdReceiptLong);
export const StockIcon = createIcon(MdStorage);
export const PromotionsIcon = createIcon(MdLocalOffer);
export const RouteMapIcon = createIcon(MdMap);
export const TieringIcon = createIcon(MdEmojiEvents);
export const DensityIcon = createIcon(MdBarChart);
